import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import { ProgramFilterOptionItem } from './filter-option-item';
import programApi from '@src/features/programs/services/program-api';

export const programFilterConfig = createEntityFilterConfig({
  facetName: 'programs',
  fetchInfiniteData: programApi.useFetchInfinite,
  entityType: STATIC_FILTER_ENTITY_TYPES.program,
  getValue: (item) => String(item.id),
  renderItem: ProgramFilterOptionItem,
});
